import gql from 'graphql-tag';

export default gql`
  mutation deleteMedia($id: UUID!, $libraryItemId: UUID, $libraryId: UUID) {
    deleteMedia(_id: $id, libraryItemId: $libraryItemId, libraryId: $libraryId)
  }
`;
